/* eslint-disable react/no-unescaped-entities */
import React from "react";
import { Row } from "antd";
import PropTypes from "prop-types";

const AuthLayout = ({ children }) => {
  return (
    <Row
      style={{
        overflow: "hidden",
        height: "100Vh",
        backgroundColor: "#e6e4e1",
      }}
    >
      <Row style={{ width: "100%" }}>
        <div
          style={{
            width: "100vw",
            padding: 0,
            display: "flex",
            justifyContent: "center",
          }}
        >
          {children}
        </div>
      </Row>
    </Row>
  );
};

AuthLayout.propTypes = {
  children: PropTypes.any.isRequired,
};

export default AuthLayout;
